import React, { Fragment, useContext, useState } from "react";
import { Button, Media, Table, TabPane } from "reactstrap";
import {
  Capacity,
  Comment,
  DateCreated,
  DateModified,
  Infrastructure,
  LinkStatus,
  LinkType,
  Name,
  Pop,
  Product,
} from "../../../../../../Constant";
import ViewModal from "../../../../../Common/Component/ViewModal";
import { formatDateWithTimeZone } from "../../../../../../_helper/dateHelper";
import useTechnicalLinkList from "./controller";
import { ContactTypeVal } from "../../../../../../Data/FormField/PublicData";
import DataTableServerFetchComponent from "../../../../../Common/Component/DataTableServerFetchComponent";
import GenerateFormTwo from "../../../../../Common/Component/GenerateFormTwo";

const TechnicalLinkList = (name: any) => {
  const {
    newBtn,
    data,
    tableColumns,
    handleView,
    handleEdit,
    viewModalOpen,
    selectedRowData,
    setViewModalOpen,
    formFields,
    memoizedHandleEdit,
    editMode,
    title,
    loading,
    totalRows,
    handlePageChange,
    handlePerRowsChange,

    fetchData,
    filterformFields,
    showFilter,
    toggleFilterVisibility,
  } = useTechnicalLinkList();

  return (
    <Fragment>
      <TabPane className="fade show" tabId={name.name}>
        {/* <DataTableComponent
          tabledata={data}
          tableColumns={tableColumns}
          isLoading={loading}
          onView={handleView}
          // onDelete={handleDelete}
          onEdit={handleEdit}
          useTableAction={undefined}
          addToDefaultAction={undefined}
          onDelete={undefined}
        /> */}

        <div className="d-flex justify-content-between pull-right mt-0">
          <Button
            color={showFilter ? "danger" : "warning"}
            className=""
            onClick={toggleFilterVisibility}
          >
            <i
              className={`fa fa-${showFilter ? "times-circle-o" : "filter"}`}
            ></i>
            &nbsp;
          </Button>
        </div>

        {showFilter && (
          <div className="mt-5">
            <GenerateFormTwo
              formFields={filterformFields}
              formTitle={undefined}
              actions={[
                {
                  name: "allLinkData",
                  label: "Filter Link",
                  onClick: fetchData,
                  color: "danger",
                },
              ]}
            />
          </div>
        )}

        <DataTableServerFetchComponent
          tabledata={data}
          tableColumns={tableColumns}
          isLoading={loading}
          onView={handleView}
          onDelete={undefined}
          useTableAction={undefined}
          addToDefaultAction={undefined}
          onEdit={handleEdit}
          totalRows={totalRows}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />

        <ViewModal
          isOpen={viewModalOpen}
          toggle={() => setViewModalOpen(!viewModalOpen)}
          rowData={selectedRowData}
          formFields={formFields}
          editMode={editMode}
          onEdit={memoizedHandleEdit}
          onSubmit={undefined}
          modalTitle={undefined}
        >
          {selectedRowData && (
            <>
              <Table>
                <tbody>
                  <tr className="border-bottom-primary">
                    <th scope="row">{Name}</th>
                    <td>{ContactRow(selectedRowData)}</td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Product}</th>
                    <td>{selectedRowData.product?.name ?? ""}</td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Capacity}</th>
                    <td>
                      {selectedRowData.product?.capacity.description ?? ""}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{LinkType}</th>
                    <td>
                      {selectedRowData.link_technical_detail?.link_type.name ??
                        ""}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Pop}</th>
                    <td>
                      {selectedRowData.link_technical_detail?.location.name ??
                        ""}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Infrastructure}</th>
                    <td>
                      {selectedRowData.link_technical_detail?.infrastructure
                        ?.name ?? ""}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{LinkStatus}</th>
                    <td>
                      {selectedRowData.link_technical_detail?.link_status
                        ?.name ?? ""}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Comment}</th>
                    <td>{selectedRowData.remark}</td>
                  </tr>

                  {/* <tr className="border-bottom-primary">
                    <th scope="row">{Description}</th>
                    <td>{selectedRowData.description}</td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{Status}</th>
                    <td>
                      {selectedRowData.is_active ? (
                        <span className="badge badge-light-success">
                          Active
                        </span>
                      ) : (
                        <span className="badge badge-light-danger">
                          Inactive
                        </span>
                      )}
                    </td>
                  </tr> */}
                  <tr className="border-bottom-primary">
                    <th scope="row">{DateCreated}</th>
                    <td>
                      {formatDateWithTimeZone(selectedRowData.created_at)}
                    </td>
                  </tr>

                  <tr className="border-bottom-primary">
                    <th scope="row">{DateModified}</th>
                    <td>
                      {formatDateWithTimeZone(selectedRowData.updated_at)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </ViewModal>
      </TabPane>
    </Fragment>
  );
};

export default TechnicalLinkList;

export const ContactRow = (row: any) => {
  return (
    <>
      <Media className="d-flex">
        <Media body className="align-self-center">
          <div>
            {row.contact.contact_type === ContactTypeVal.Individual
              ? `${row.contact.last_name} ${row.contact.first_name} ${row.contact.middle_name}`
              : `${row.contact?.company_name}`}{" "}
            ({row.contact?.contact_number})
          </div>
        </Media>
      </Media>
    </>
  );
};
